
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { TrendingUp, TrendingDown } from 'lucide-react';

// Sample data for service performance
const servicePerformanceData = [
  { 
    id: 1, 
    service: 'Dental Implants', 
    cases: 32, 
    avgRevenue: 2800, 
    avgSessions: 5.2, 
    trending: 'up',
    profit: 'high'
  },
  { 
    id: 2, 
    service: 'Full Mouth Reconstruction', 
    cases: 8, 
    avgRevenue: 9500, 
    avgSessions: 8.5, 
    trending: 'up',
    profit: 'high'
  },
  { 
    id: 3, 
    service: 'Veneers', 
    cases: 24, 
    avgRevenue: 4200, 
    avgSessions: 3.8, 
    trending: 'up',
    profit: 'medium'
  },
  { 
    id: 4, 
    service: 'Root Canal', 
    cases: 18, 
    avgRevenue: 950, 
    avgSessions: 2.2, 
    trending: 'down',
    profit: 'low'
  },
  { 
    id: 5, 
    service: 'Teeth Whitening', 
    cases: 42, 
    avgRevenue: 650, 
    avgSessions: 1.5, 
    trending: 'up',
    profit: 'medium'
  }
];

const ServicePerformanceTable: React.FC = () => {
  return (
    <div>
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Service</TableHead>
              <TableHead className="text-right">Cases</TableHead>
              <TableHead className="text-right">Avg. Revenue</TableHead>
              <TableHead className="text-right">Avg. Sessions</TableHead>
              <TableHead className="text-right">Trend</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {servicePerformanceData.map((service) => (
              <TableRow key={service.id} className={service.profit === 'high' ? 'bg-green-50' : ''}>
                <TableCell className="font-medium">{service.service}</TableCell>
                <TableCell className="text-right">{service.cases}</TableCell>
                <TableCell className="text-right">${service.avgRevenue.toLocaleString()}</TableCell>
                <TableCell className="text-right">{service.avgSessions}</TableCell>
                <TableCell className="text-right">
                  {service.trending === 'up' ? (
                    <div className="flex items-center justify-end text-green-600">
                      <TrendingUp className="h-4 w-4 mr-1" />
                      <span>Up</span>
                    </div>
                  ) : (
                    <div className="flex items-center justify-end text-red-600">
                      <TrendingDown className="h-4 w-4 mr-1" />
                      <span>Down</span>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-blue-50 p-3 rounded-md">
          <div className="text-sm text-muted-foreground">Total Cases</div>
          <div className="text-xl font-bold">124</div>
        </div>
        <div className="bg-green-50 p-3 rounded-md">
          <div className="text-sm text-muted-foreground">Avg. Revenue/Case</div>
          <div className="text-xl font-bold">$2,430</div>
        </div>
        <div className="bg-amber-50 p-3 rounded-md">
          <div className="text-sm text-muted-foreground">Most Popular</div>
          <div className="text-xl font-bold">Teeth Whitening</div>
        </div>
        <div className="bg-purple-50 p-3 rounded-md">
          <div className="text-sm text-muted-foreground">Most Profitable</div>
          <div className="text-xl font-bold">Full Mouth Recon.</div>
        </div>
      </div>
    </div>
  );
};

export default ServicePerformanceTable;
